<template>
  <footer class="footer">
    <!-- <v-footer> -->
        <div class="container container-principal">
        <div class="row">
        <div class="col-lg-9 col-6 mt-5">
            <img :src="urlImg" class="mb-4">
          </div>
          <!-- @if((session()->get('name')) == 'Visitante')
            <div class="d-flex justify-content-center align-items-center col-lg-3 col-6 mt-5">
              <a class="btn btn-primary btn-teste-footer" href="{{asset('')}}cadastro">Teste Grátis</a>
            </div>
          @endif -->
        </div>
        <div class="row">
          <div class="col-lg-4">
            <a class="d-md-inline-block d-flex justify-content-center btn btn-primary btn-central-footer mb-5 mt-3" :href="urlCentralDeAjuda">Central de ajuda</a>
            <div class="d-md-inline-block pl-md-5 pl-lg-0">
              <p>FALE CONOSCO</p>
              <ul>
                <li>
                  <i class="fab fa-whatsapp">
                    <span class="ml-1">(51) 99892-8501</span>
                  </i>
                </li>
                <li>
                  <i class="far fa-envelope">
                  <span class="ml-1">vistaseu@jaleko.com.br</span>
                  </i>
                </li>
                <li class="mt-5 d-none d-lg-block">
                  <p>Baixe nosso app</p>
                  <a :href="'https://play.google.com/store/apps/details?id=com.jaleko.app'" class="img-a" target="_blank"><img class="img-fluid" :src="urlImgGoogle"></a>
                  <a :href="'https://apps.apple.com/br/app/jaleko-curso-de-medicina/id1453744540'" class="img-a" target="_blank"><img class="img-fluid" :src="urlImgApple"></a>
                </li>
                <li class="mt-5 d-none d-lg-block">
                  <img :src="urlImgPagamento">
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="row ml-lg-5">
              <div class="mt-4 col-md-4">
                <div class="d-md-none accordion-footer" id="accordionInstitucional">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingInstitucional">
                      <button class="accordion-btn" type="button" data-toggle="collapse" data-target="#collapseInstitucional" aria-expanded="true" aria-controls="collapseInstitucional">
                        <p>Institucional</p>
                      </button>
                    </h2>
                    <div id="collapseInstitucional" class="accordion-collapse collapse show" aria-labelledby="headingInstitucional" data-bs-parent="#accordionInstitucional">
                      <div class="accordion-body">
                      <ul>
                          <li><a :href="'https://www.grupoa.com.br'" target="_blank">+A Educação</a></li>
                          <li><a :href="'https://www.artmed.com.br'" target="_blank">Artmed</a></li>
                          <li><a :href="'https://maisaedu.gupy.io'" target="_blank">Trabalhe conosco</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-none d-md-block">
                  <p>Institucional</p>
                  <ul>
                    <li><a :href="'https://www.grupoa.com.br'" target="_blank">+A Educação</a></li>
                    <li><a :href="'https://www.artmed.com.br'" target="_blank">Artmed</a></li>
                    <li><a :href="'https://maisaedu.gupy.io'" target="_blank">Trabalhe conosco</a></li>
                  </ul>
                </div>
              </div>
              <div class="mt-4 col-md-4">
                <div class="d-md-none accordion-footer" id="accordionMarcas">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingMarcas">
                      <button class="accordion-btn collapsed" type="button" data-toggle="collapse" data-target="#collapseMarcas" aria-expanded="true" aria-controls="collapseMarcas">
                        <p>Nossas marcas</p>
                      </button>
                    </h2>
                    <div id="collapseMarcas" class="accordion-collapse collapse" aria-labelledby="headingMarcas" data-bs-parent="#accordionMarcas">
                      <div class="accordion-body">
                      <ul>
                          <li><a :href="'https://loja.grupoa.com.br'" target="_blank">Loja Grupo A</a></li>
                          <li><a :href="'https://secad.artmed.com.br'" target="_blank">Secad</a></li>
                          <li><a :href="'https://www.artmed360.com.br'" target="_blank">Artmed360</a></li>
                          <li><a :href="'https://www.posartmed.com.br'" target="_blank">Pós Artmed</a></li>
                          <li><a :href="'https://www.medicinanet.com.br'" target="_blank">MedicinaNet</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-none d-md-block">
                  <p>Nossas marcas</p>
                  <ul>
                    <li><a :href="'https://loja.grupoa.com.br'" target="_blank">Loja Grupo A</a></li>
                    <li><a :href="'https://secad.artmed.com.br'" target="_blank">Secad</a></li>
                    <li><a :href="'https://www.artmed360.com.br'" target="_blank">Artmed360</a></li>
                    <li><a :href="'https://www.posartmed.com.br'" target="_blank">Pós Artmed</a></li>
                    <li><a :href="'https://www.medicinanet.com.br'" target="_blank">MedicinaNet</a></li>
                  </ul>
                </div>
              </div>
              <div class="mt-4 col-md-4">
                <div class="d-md-none accordion-footer" id="accordionSobre">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSobre">
                      <button class="accordion-btn collapsed" type="button" data-toggle="collapse" data-target="#collapseSobre" aria-expanded="true" aria-controls="collapseSobre">
                        <p>Sobre o Jaleko</p>
                      </button>
                    </h2>
                    <div id="collapseSobre" class="accordion-collapse collapse" aria-labelledby="headingSobre" data-bs-parent="#accordionSobre">
                      <div class="accordion-body">
                        <ul>
                          <li><a :href="urlQuemSomos">Quem somos</a></li>
                          <li><a :href="urlCursos">Cursos</a></li>
                          <li><a :href="urlPlano">Planos</a></li>
                          <li><a :href="urlFerramentas">Ferramentas</a></li>
                          <li><a :href="'https://blog.jaleko.com.br'" target="_blank">Blog</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-none d-md-block">
                  <p>Sobre o Jaleko</p>
                  <ul>
                    <li><a :href="urlQuemSomos">Quem somos</a></li>
                    <li><a :href="urlCursos">Cursos</a></li>
                    <li><a :href="urlPlano">Planos</a></li>
                    <li><a :href="urlFerramentas">Ferramentas</a></li>
                    <li><a :href="'https://blog.jaleko.com.br'" target="_blank">Blog</a></li>
                  </ul>
                </div>
              </div>
              <div class="mt-4 col-md-4">
                <div class="d-md-none accordion-footer" id="accordionFerramentas">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFerramentas">
                      <button class="accordion-btn collapsed" type="button" data-toggle="collapse" data-target="#collapseFerramentas" aria-expanded="true" aria-controls="collapseFerramentas">
                        <p>Ferramentas</p>
                      </button>
                    </h2>
                    <div id="collapseFerramentas" class="accordion-collapse collapse" aria-labelledby="headingFerramentas" data-bs-parent="#accordionFerramentas">
                      <div class="accordion-body">
                        <ul>
                          <li><a :href="urlFlashcards">Flashcards</a></li>
                          <li><a :href="urlSimuladoLista">Simulados</a></li>
                          <li><a :href="urlResumos">Resumos</a></li>
                          <li><a :href="urlModelos3D">Modelos 3D</a></li>
                          <li><a :href="urlMapasMentais">Mapas Mentais</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-none d-md-block">
                  <p>Ferramentas</p>
                  <ul>
                    <li><a :href="urlFlashcards">Flashcards</a></li>
                    <li><a :href="urlSimuladoLista">Simulados</a></li>
                    <li><a :href="urlResumos">Resumos</a></li>
                    <li><a :href="urlModelos3D">Modelos 3D</a></li>
                    <li><a :href="urlMapasMentais">Mapas Mentais</a></li>
                  </ul>
                </div>
              </div>
              <div class="mt-4 col-md-4">
                <div class="d-md-none accordion-footer" id="accordionCursos">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingCursos">
                      <button class="accordion-btn collapsed" type="button" data-toggle="collapse" data-target="#collapseCursos" aria-expanded="true" aria-controls="collapseCursos">
                        <p>Cursos</p>
                      </button>
                    </h2>
                    <div id="collapseCursos" class="accordion-collapse collapse" aria-labelledby="headingCursos" data-bs-parent="#accordionCursos">
                      <div class="accordion-body">
                      <ul>
                          <li><a :href="urlCursos+'/1'">Ciclo Básico</a></li>
                          <li><a :href="urlCursos+'/2'">Propedêutica e Semiologia</a></li>
                          <li><a :href="urlCursos+'/3'">SUS e Preventiva</a></li>
                          <li><a :href="urlCursos+'/4'">Especialidades Clínicas e Cirúrgicas</a></li>
                          <li><a :href="urlCursos+'/5'">Internato e Prática Médica</a></li>
                          <li><a :href="urlCursos+'/6'">Saúde Inova</a></li>
                          <li><a :href="urlCursos+'/10'">Concursos</a></li>
                          <li><a :href="urlCursos+'/25'">Projetos de YouTube</a></li>
                          <li><a :href="urlCursos+'/26'">Academia Nacional de Medicina</a></li>
                          <li><a :href="urlCursos+'/51'">Suporte aos Estudos</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-none d-md-block">
                  <p>Cursos</p>
                  <ul>
                    <li><a :href="urlCursos+'/1'">Ciclo Básico</a></li>
                    <li><a :href="urlCursos+'/2'">Propedêutica e Semiologia</a></li>
                    <li><a :href="urlCursos+'/3'">SUS e Preventiva</a></li>
                    <li><a :href="urlCursos+'/4'">Especialidades Clínicas e Cirúrgicas</a></li>
                    <li><a :href="urlCursos+'/5'">Internato e Prática Médica</a></li>
                  </ul>
                </div>
              </div>
              <div class="d-none d-md-block mt-4 col-md-4">
                <p class="cursos-footer">Cursos</p>
                <ul>
                  <li><a :href="urlCursos+'/6'">Saúde Inova</a></li>
                  <li><a :href="urlCursos+'/10'">Concursos</a></li>
                  <li><a :href="urlCursos+'/25'">Projetos de YouTube</a></li>
                  <li><a :href="urlCursos+'/26'">Academia Nacional de Medicina</a></li>
                  <li><a :href="urlCursos+'/51'">Suporte aos Estudos</a></li>
                </ul>
              </div>
              <div class="d-lg-none col-lg-4 mb-4 mb-md-0">
                <ul class="d-md-flex">
                <li class="mr-md-5 mt-5 d-flex flex-wrap">
                    <p class="w-100">Baixe nosso app</p>
                    <a :href="'https://play.google.com/store/apps/details?id=com.jaleko.app'" class="d-flex img-a w-50" target="_blank"><img class="img-fluid w-100" :src="urlImgGoogle"></a>
                    <a :href="'https://apps.apple.com/br/app/jaleko-curso-de-medicina/id1453744540'" class="d-flex img-a w-50" target="_blank"><img class="img-fluid w-100 pl-3" :src="urlImgApple"></a>
                  </li>
                  <li class="mt-5 d-flex flex-wrap">
                    <p class="w-100">Pagamento</p>
                    <img class="img-fluid w-100" :src="urlImgPagamento">
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="barra-footer">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-7 copyright">
                        <div class="row">
                        <div class="d-flex justify-content-lg-between justify-content-md-around align-items-start flex-column flex-md-row col-12">
                        <span class="mt-md-0 mb-md-0">JALEKO © {{ano}}</span>
                        <a :href="urlPoliticaPrivacidade" class="mb-md-0">Política de privacidade</a>
                        <a :href="'https://privacyportal-br.onetrust.com/webform/a9d01efe-da9a-499b-bd16-9200a272918e/6f0d16d3-251c-4dc7-9de0-81e389f6b442'" class="mb-4 mb-md-0">Fale com o DPO</a>
                        <a :href="urlPoliticaCookies" class="mb-md-0">Política Cookies</a>
                        <a :href="urlTermosUso" class="mb-md-0">Termos de uso</a>
                        </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between col-md-12 col-lg-5 social mb-md-0">
                    <a :href="'https://pt-br.facebook.com/grupoJaleko'" target="_blank"><i class="fab fa-facebook fa-lg white-text mr-md-5 mr-3 fa-2x"></i></a>
                    <a :href="'https://www.instagram.com/jalekoacademicos'" target="_blank"><i class="fab fa-instagram fa-lg white-text mr-md-5 mr-3 fa-2x"></i></a>
                    <a :href="'https://twitter.com/JalekoAcad/'" target="_blank"><i class="fab fa-twitter fa-lg white-text mr-md-5 mr-3 fa-2x"></i></a>
                    <a :href="'https://www.youtube.com/channel/UCoGDzJkGOb2YfM-VQ9rJyMg'" target="_blank"><i class="fab fa-youtube fa-lg white-text mr-md-5 mr-3 fa-2x"></i></a>
                    <a :href="'https://br.linkedin.com/company/jaleko'" target="_blank"><i class="fab fa-linkedin fa-lg white-text mr-md-5 mr-3 fa-2x"></i></a>
                    <a :href="'https://blog.jaleko.com.br'" target="_blank"><img class="blog" :src="urlImgBlog"></a>
                    </div>
                </div>
            </div>
        </div>
    <!-- </v-footer> -->
</footer>
</template>

<script>
import DateUtils from '@/core/utils/date-utils'
import { mapState } from 'vuex'

export default {
  name: 'AppFooter',
  data () {
    return {
      ano: DateUtils.formatDate(new Date(), 'YYYY')
    }
  },
  computed: {
    ...mapState({
      logo: (state) => state.configEmpresa.logo,
      usuario: (state) => state.usuario
    }),

    urlTermosUso: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}documentos/termos+e+cond-uso-fev2020_final.pdf`
    },

    urlPoliticaPrivacidade: function () {
      return 'https://maisaedu.com.br/privacidade/jaleko'
    },

    urlPoliticaCookies: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}a/politica_cookies`
    },

    urlFaq: function () {
      return `${process.env.VUE_APP_URL}faq`
    },
    urlImg: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/logo_footer_J.png`
    },
    urlImgGoogle: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/google_footer.svg`
    },
    urlImgApple: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/apple_footer.svg`
    },
    urlImgPagamento: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/pagamento.png`
    },
    urlCentralDeAjuda: function () {
      return `${process.env.VUE_APP_URL}central-de-ajuda`
    },
    urlCursos: function () {
      return `${process.env.VUE_APP_URL}cursos`
    },
    urlPlano: function () {
      return `${process.env.VUE_APP_URL}plano`
    },
    urlLogin: function () {
      return `${process.env.VUE_APP_URL}login`
    },
    urlAplicativo: function () {
      return `${process.env.VUE_APP_URL}aplicativo`
    },
    urlQuemSomos: function () {
      return `${process.env.VUE_APP_URL}quemsomos`
    },
    urlPrincipal: function () {
      return `${process.env.VUE_APP_URL}home`
    },
    urlFlashcards: function () {
      return `${process.env.VUE_APP_URL}flashcards`
    },
    urlSimuladoLista: function () {
      return `${process.env.VUE_APP_URL}simuladolista`
    },
    urlResumos: function () {
      return `${process.env.VUE_APP_URL}ferramentas?tool=resumos`
    },
    urlModelos3D: function () {
      return `${process.env.VUE_APP_URL}ferramentas?tool=modelos-3d`
    },
    urlMapasMentais: function () {
      return `${process.env.VUE_APP_URL}ferramentas?tool=mapas-mentais`
    },
    urlFerramentas: function () {
      return `${process.env.VUE_APP_URL}ferramentas`
    },
    urlImgBlog: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/blog_footer.png`
    }

  }
}
</script>

<style scoped>

</style>
